import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Copyright © 2022 ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Created by ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CLink = _resolveComponent("CLink")!
  const _component_CFooter = _resolveComponent("CFooter")!

  return (_openBlock(), _createBlock(_component_CFooter, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_CLink, {
          href: "https://planerSlubu.pl",
          target: "_blank",
          rel: "noopener"
        }, {
          default: _withCtx(() => [
            _createTextVNode("PlanerSlubu.pl")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_CLink, {
          href: "https://flatart.pl",
          target: "_blank",
          rel: "noopener"
        }, {
          default: _withCtx(() => [
            _createTextVNode("FlatArt")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}